import { Box, Typography } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { HOPE_SANS } from "@/shared/branding/thehopeonebrand";

const c = {
  forestDeep: "#102C24",
  forest: "#1D4437",
  green: "#5E8F72",
  paper: "#FFFFFF",
  muted: "#68766F",
  border: "rgba(16,44,36,.10)",
};

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["blockquote", "code-block"],
    ["link", "image", "video"],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ["clean"],
  ],
};

type ImpactQuillFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  minHeight?: number;
  placeholder?: string;
  compact?: boolean;
};

export function ImpactQuillField({
  label,
  value,
  onChange,
  minHeight = 140,
  placeholder,
  compact = false,
}: ImpactQuillFieldProps) {
  const modules = compact
    ? {
        toolbar: [
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
        ],
      }
    : QUILL_MODULES;
  return (
    <Box sx={{ mb: 1.75 }}>
      <Typography
        sx={{
          mb: 0.75,
          fontFamily: HOPE_SANS,
          fontSize: "0.78rem",
          fontWeight: 700,
          color: c.muted,
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          borderRadius: "12px",
          overflow: "visible",
          border: `1px solid ${c.border}`,
          bgcolor: c.paper,
          "& .ql-toolbar": {
            border: "none",
            borderBottom: `1px solid ${c.border}`,
            bgcolor: "#F7F4EC",
            fontFamily: HOPE_SANS,
          },
          "& .ql-container": {
            border: "none",
            fontFamily: HOPE_SANS,
            fontSize: "0.92rem",
            color: c.forestDeep,
          },
          "& .ql-editor": {
            minHeight,
          },
          "& .ql-editor.ql-blank::before": {
            color: c.muted,
            fontStyle: "normal",
          },
          "& .ql-stroke": { stroke: c.forest },
          "& .ql-fill": { fill: c.forest },
          "& button:hover .ql-stroke, & button.ql-active .ql-stroke": { stroke: c.green },
        }}
      >
        <ReactQuill
          theme="snow"
          value={value || ""}
          onChange={onChange}
          placeholder={placeholder}
          modules={modules}
        />
      </Box>
    </Box>
  );
}

export function stripImpactHtml(value?: string | null): string {
  return String(value ?? "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
}
